import { Divider, Stack, Typography } from '@mui/material';
import {
  type AzureRestorePointData,
  type InventoryResource,
} from '@repo/api-gw-sdk';
import { useEffect, useState } from 'react';

import { MultiAccordionsItem } from '@/components/accordion/multiAccordionsItem';
import { OtherSnapshotsDetails } from '@/components/snapshots/convertToEon/otherSnapshotsDetails';
import { OtherSnapshotsSummary } from '@/components/snapshots/convertToEon/otherSnapshotsSummary';
import { extractDiskName } from '@/utils/azure';

import SnapshotSelectionEmptyState from '../snapshotSelection/snapshotSelectionEmptyState';

interface AzureRestorePointsListProps {
  resource: InventoryResource;
  restorePoints: AzureRestorePointData[];
}

export const AzureRestorePointsList = (props: AzureRestorePointsListProps) => {
  const { restorePoints, resource } = props;
  const [selectedId, setSelectedId] = useState(
    restorePoints[0]?.restorePointId
  );

  // Match AWS pattern: auto-select first item when list changes
  useEffect(() => {
    setSelectedId(restorePoints[0]?.restorePointId);
  }, [restorePoints]);

  if (!restorePoints.length) {
    return (
      <Stack marginY='40px'>
        <SnapshotSelectionEmptyState description="Couldn't find Azure restore points" />
      </Stack>
    );
  }

  return (
    <Stack width='100%'>
      {restorePoints.map((rp) => (
        <div key={rp.restorePointId}>
          <MultiAccordionsItem
            isSelected={selectedId === rp.restorePointId}
            onSelect={() => setSelectedId(rp.restorePointId)}
            isMulti={restorePoints.length > 1}
            Summary={
              <OtherSnapshotsSummary
                isMultiTimes={restorePoints.length > 1}
                time={rp.createdAt}
                numOfVols={rp.diskIds?.length || 0}
                restorePointType={rp.restorePointType}
                volLabel='disk'
              />
            }
            Details={
              <OtherSnapshotsDetails
                resource={resource}
                azureRestorePoint={rp}
                time={rp.createdAt}
              >
                <Stack
                  direction='row'
                  gap='12px'
                  alignItems='center'
                  flexWrap='wrap'
                >
                  {rp.diskIds?.map((diskId) => (
                    <Typography
                      key={diskId}
                      fontSize='12px'
                      fontFamily='monospace'
                    >
                      {extractDiskName(diskId)}
                    </Typography>
                  ))}
                </Stack>
              </OtherSnapshotsDetails>
            }
          />
          <Divider />
        </div>
      ))}
    </Stack>
  );
};
